<template>
  <el-dialog :append-to-body="true" :close-on-click-modal="false" id="reset-password-layer" title="修改密码"
    :visible.sync="dialogVisible" width="530px">
    <div class="reset-phone">
      已绑定手机号 <span>{{ phone }}</span>
    </div>
    <el-form @submit.native.prevent :model="resetForm" :rules="resetRules" ref="resetForm" label-width="0"
      class="reset-Form">
      <el-form-item prop="smgcode">
        <el-input size="small" placeholder="请输入短信验证码" maxlength="6" v-model="resetForm.smgcode"
          oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        <div class="code-btn">
          <el-button class="right-btn" size="small" type="primary" plain :disabled="!sendAuthCode" @click="getMsgAuthCode"
            v-show="sendAuthCode">获取验证码</el-button>
          <el-button type="primary" size="small" plain v-show="!sendAuthCode" class="right-btn">
            {{ auth_time }}秒</el-button>
        </div>
      </el-form-item>
      <el-form-item prop="pass">
        <el-input size="small" type="password" maxlength="14" placeholder="请输入8-14位数字和字母组合（区分大小写）" v-model="resetForm.pass"></el-input>
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input size="small" type="password" maxlength="14" placeholder="请您再次输入密码" v-model="resetForm.checkPass"></el-input>
      </el-form-item>
    </el-form>

    <div class="dialog-btns">
      <el-button type="primary" size="small" @click="submitHandle" class="btn-ok">确认</el-button>
      <el-button plain size="small" @click="cancel" class="btn-cancel">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from "vuex";
import { getSmsVerificationCode } from "@/api/common";
import { changePassword } from "@/api/account/account";
export default {
  data() {
    // 密码正则
    var passwordReg = (rule, value, callback) => {
      var pReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,14}$/;
      if (!pReg.test(value)) {
        callback(new Error("密码格式不正确！数字字母，8-14位！"));
      } else {
        callback();
      }
    };

    // 验证密码
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.resetForm.checkPass !== "") {
          this.$refs.resetForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.resetForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      dialogVisible: false,
      resetForm: {
        smgcode: "",
        pass: "",
        checkPass: "",
      },
      resetRules: {
        smgcode: [
          { required: true, message: "请输入短信验证码", trigger: "change" },
        ],
        pass: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
          { validator: passwordReg, trigger: "blur" },
        ],
        checkPass: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
          { validator: passwordReg, trigger: "blur" },
        ],
      },
      auth_time: 60,
      sendAuthCode: true,
    };
  },
  computed: {
    phone() {
      var str1 = "";
      if (this.userInfo.phone) {
        str1 = this.userInfo.phone.replace(
          /(\d{3})(\d+)(\d{4})/,
          function (x, y, z, p) {
            var i = "";
            while (i.length < z.length) {
              i += "*";
            }
            return y + i + p;
          }
        );
        return str1;
      }
    },
    ...mapState(["userInfo"]),
  },
  methods: {
    getMsgAuthCode() {
      this.sendAuthCode = false;
      getSmsVerificationCode({
        bizType: "changePwd",
      })
        .then((res) => {
          if (res.code != "200") {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
            this.sendAuthCode = true;
            this.auth_time = 60;
          } else {
            this.$message({
              message: "短信发送成功",
              type: "success",
            });
            // 倒计时

            this.auth_time = 60;
            var auth_timetimer = setInterval(() => {
              this.auth_time--;
              if (this.auth_time <= 0) {
                this.sendAuthCode = true;
                clearInterval(auth_timetimer);
              }
            }, 1000);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$message.error('服务器错误！');
        });
    },
    submitHandle() {
      this.$refs["resetForm"].validate((valid) => {
        if (valid) {
          changePassword({
            vcode: this.resetForm.smgcode,
            password: this.resetForm.pass,
          }).then((res) => {
            if (res.code != 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "warning",
              });
            } else {
              this.$message({
                showClose: true,
                message: "密码修改成功，请重新登录！",
                type: "success",
              });

              setTimeout(() => {
                this.cancel();
                this.logout();
              }, 200);
            }
          });
        } else {
          return false;
        }
      });
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    cancel() {
      this.dialogVisible = false;
      this.$refs["resetForm"].resetFields();
      this.resetForm.smgcode = "";
      this.resetForm.pass = "";
      this.resetForm.checkPass = "";
    },
  },
};
</script>
<style>
/* .reset-Form input,
.reset-Form button {
  height: 48px;
} */
</style>
<style scoped>
.reset-phone {
  /* font-size: 14px;
  color: #333333;
  width: 400px; */
  margin: 0 auto 22px;
}

.code-btn {
  position: absolute;
  right: 0;
  top: 0;
}

/* .reset-Form {
  width: 400px;
  margin: 0 auto;
} */

/* .dialog-btns {
  width: 400px;
  margin: 40px auto 0;
  overflow: hidden;
} */

/* .dialog-btns button {
  display: block;
  width: 140px;
  height: 40px;
  font-size: 14px;
  border-radius: 6px;
  float: left;
} */

.right-btn {
  border-radius: 0 4px 4px 0;
}
</style>
